<template>
  <div>
    <van-field
      left-icon="bookmark"
      v-model="$store.state.textbookValue"
      is-link
      readonly
      label="模块"
      placeholder="点击选择模块"
      @click="showPickerTextbook = true"
    />
    <van-popup
      v-model="showPickerTextbook"
      round
      position="bottom"
      :style="{ height: '100%' }"
    >
      <van-nav-bar
        title="选择教材模块"
        left-text="返回"
        right-text=""
        left-arrow
        @click-left="showPickerTextbook = false"
        @click-right=""
      />
      <van-row type="flex" justify="space-between">
        <van-col span="6">
          <van-button style="" type="default" plain @click="filterTextbook()"
            >确认</van-button
          >
        </van-col>
        <van-col span="10">
          <van-cell center title="保存选中" style="font-size: 13px">
            <template #right-icon>
              <van-switch
                v-model="$store.state.checkedTextbookSave"
                size="24"
              />
            </template>
          </van-cell>
        </van-col>
        <van-col span="4">
          <van-button style="" type="default" plain @click="clearTextbook()"
            >清空</van-button
          >
        </van-col>
      </van-row>
      <van-collapse v-model="activeNames" accordion ref="collapsitems">
        <van-collapse-item
          title="新七年级上"
          :value="newjuniorOneText"
          name="新七年级上"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="newcheckJuniorOneAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="newtoggleJuniorOneAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>

          <van-checkbox-group
            v-model="newjuniorOneSelected"
            ref="checkboxGroup01"
          >
            <van-cell-group
              v-for="(module, index) in newjuniorColumns"
              :key="module"
            >
              <van-cell
                clickable
                :title="`${module}`"
                @click="newtoggleJuniorOne(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes01" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="新七年级下"
          :value="newjuniorTwoText"
          name="新七年级下"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="newcheckJuniorTwoAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="newtoggleJuniorTwoAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>

          <van-checkbox-group
            v-model="newjuniorTwoSelected"
            ref="checkboxGroup02"
          >
            <van-cell-group
              v-for="(module, index) in newjuniorColumns"
              :key="module"
            >
              <van-cell
                clickable
                :title="`${module}`"
                @click="newtoggleJuniorTwo(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes02" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="新八年级上"
          :value="newjuniorThreeText"
          name="新八年级上"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="newcheckJuniorThreeAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="newtoggleJuniorThreeAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>

          <van-checkbox-group
            v-model="newjuniorThreeSelected"
            ref="checkboxGroup03"
          >
            <van-cell-group
              v-for="(module, index) in newjuniorColumns"
              :key="module"
            >
              <van-cell
                clickable
                :title="`${module}`"
                @click="newtoggleJuniorThree(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes03" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="新八年级下"
          :value="newjuniorFourText"
          name="新八年级下"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="newcheckJuniorFourAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="newtoggleJuniorFourAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>

          <van-checkbox-group
            v-model="newjuniorFourSelected"
            ref="checkboxGroup04"
          >
            <van-cell-group
              v-for="(module, index) in newjuniorColumns"
              :key="module"
            >
              <van-cell
                clickable
                :title="`${module}`"
                @click="newtoggleJuniorFour(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes04" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="新九年级上"
          :value="newjuniorFiveText"
          name="新九年级上"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="newcheckJuniorFiveAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="newtoggleJuniorFiveAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>

          <van-checkbox-group
            v-model="newjuniorFiveSelected"
            ref="checkboxGroup05"
          >
            <van-cell-group
              v-for="(module, index) in newjuniorColumns"
              :key="module"
            >
              <van-cell
                clickable
                :title="`${module}`"
                @click="newtoggleJuniorFive(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes05" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="新九年级下"
          :value="newjuniorSixText"
          name="新九年级下"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="newcheckJuniorSixAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="newtoggleJuniorSixAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>

          <van-checkbox-group
            v-model="newjuniorSixSelected"
            ref="checkboxGroup06"
          >
            <van-cell-group
              v-for="(module, index) in newjuniorColumns"
              :key="module"
            >
              <van-cell
                clickable
                :title="`${module}`"
                @click="newtoggleJuniorSix(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes06" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="七年级上"
          :value="juniorOneText"
          name="七年级上"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkJuniorOneAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleJuniorOneAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>

          <van-checkbox-group v-model="juniorOneSelected" ref="checkboxGroup1">
            <van-cell-group v-for="(module, index) in juniorOneColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleJuniorOne(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes1" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="七年级下"
          :value="juniorTwoText"
          name="七年级下"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkJuniorTwoAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleJuniorTwoAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group v-model="juniorTwoSelected" ref="checkboxGroup2">
            <van-cell-group v-for="(module, index) in juniorTwelveColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleJuniorTwo(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes2" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="八年级上"
          :value="juniorThreeText"
          name="八年级上"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkJuniorThreeAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleJuniorThreeAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group
            v-model="juniorThreeSelected"
            ref="checkboxGroup3"
          >
            <van-cell-group v-for="(module, index) in juniorTwelveColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleJuniorThree(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes3" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="八年级下"
          :value="juniorFourText"
          name="八年级下"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkJuniorFourAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleJuniorFourAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group v-model="juniorFourSelected" ref="checkboxGroup4">
            <van-cell-group v-for="(module, index) in juniorTenColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleJuniorFour(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes4" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="九年级上"
          :value="juniorFiveText"
          name="九年级上"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkJuniorFiveAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleJuniorFiveAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group v-model="juniorFiveSelected" ref="checkboxGroup5">
            <van-cell-group v-for="(module, index) in juniorTwelveColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleJuniorFive(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes5" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="九年级下"
          :value="juniorSixText"
          name="九年级下"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkJuniorSixAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleJuniorSixAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group v-model="juniorSixSelected" ref="checkboxGroup6">
            <van-cell-group v-for="(module, index) in juniorEightColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleJuniorSix(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes6" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item title="必修一" :value="seniorOneText" name="必修一">
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkSeniorOneAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleSeniorOneAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group v-model="seniorOneSelected" ref="checkboxGroup7">
            <van-cell-group v-for="(module, index) in seniorColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleSeniorOne(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes7" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item title="必修二" :value="seniorTwoText" name="必修二">
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkSeniorTwoAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleSeniorTwoAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group v-model="seniorTwoSelected" ref="checkboxGroup8">
            <van-cell-group v-for="(module, index) in seniorColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleSeniorTwo(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes8" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item
          title="必修三"
          :value="seniorThreeText"
          name="必修三"
        >
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkSeniorThreeAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleSeniorThreeAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group
            v-model="seniorThreeSelected"
            ref="checkboxGroup9"
          >
            <van-cell-group v-for="(module, index) in seniorColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleSeniorThree(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes9" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item title="选修一" :value="seniorFourText" name="选修一">
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkSeniorFourAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleSeniorFourAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group
            v-model="seniorFourSelected"
            ref="checkboxGroup10"
          >
            <van-cell-group v-for="(module, index) in seniorColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleSeniorFour(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes10" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item title="选修二" :value="seniorFiveText" name="选修二">
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkSeniorFiveAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleSeniorFiveAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group
            v-model="seniorFiveSelected"
            ref="checkboxGroup11"
          >
            <van-cell-group v-for="(module, index) in seniorColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleSeniorFive(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes11" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item title="选修三" :value="seniorSixText" name="选修三">
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkSeniorSixAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleSeniorSixAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group v-model="seniorSixSelected" ref="checkboxGroup12">
            <van-cell-group v-for="(module, index) in seniorColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleSeniorSix(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes12" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>

        <van-collapse-item title="选修四" :value="seniorSixText" name="选修四">
          <div style="margin-top: -1%; margin-bottom: 3%">
            <van-button
              type="primary"
              @click="checkSeniorSevenAll"
              class="selectAllButton"
              >全选</van-button
            >
            <van-button
              type="info"
              @click="toggleSeniorSevenAll"
              class="unSelectAllButton"
              >反选</van-button
            >
          </div>
          <van-checkbox-group
            v-model="seniorSevenSelected"
            ref="checkboxGroup13"
          >
            <van-cell-group v-for="(module, index) in seniorColumns">
              <van-cell
                clickable
                :key="module"
                :title="`${module}`"
                @click="toggleSeniorSeven(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="module" ref="checkboxes13" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-collapse-item>
      </van-collapse>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "textBook",
  props: [],
  data() {
    return {
      checkedSave: true,
      activeNames: "1",
      showPickerTextbook: false,

      juniorTenColumns: [
        "Module 1",
        "Module 2",
        "Module 3",
        "Module 4",
        "Module 5",
        "Module 6",
        "Module 7",
        "Module 8",
        "Module 9",
        "Module 10",
      ],
      juniorOneColumns: [
        "Starter 1",
        "Starter 2",
        "Starter 3",
        "Starter 4",
        "Module 1",
        "Module 2",
        "Module 3",
        "Module 4",
        "Module 5",
        "Module 6",
        "Module 7",
        "Module 8",
        "Module 9",
        "Module 10",
      ],
      juniorTwelveColumns: [
        "Module 1",
        "Module 2",
        "Module 3",
        "Module 4",
        "Module 5",
        "Module 6",
        "Module 7",
        "Module 8",
        "Module 9",
        "Module 10",
        "Module 11",
        "Module 12",
      ],
      juniorEightColumns: [
        "Module 1",
        "Module 2",
        "Module 3",
        "Module 4",
        "Module 5",
        "Module 6",
        "Module 7",
        "Module 8",
      ],
      newjuniorColumns: [
        "Unit 1",
        "Unit 2",
        "Unit 3",
        "Unit 4",
        "Unit 5",
        "Unit 6",
      ],
      seniorColumns: [
        "Unit 1",
        "Unit 2",
        "Unit 3",
        "Unit 4",
        "Unit 5",
        "Unit 6",
      ],

      newjuniorOneSelected: [],
      newjuniorOneText: "",
      newjuniorTwoSelected: [],
      newjuniorTwoText: "",
      newjuniorThreeSelected: [],
      newjuniorThreeText: "",
      newjuniorFourSelected: [],
      newjuniorFourText: "",
      // 新增：新九上、新九下数据
      newjuniorFiveSelected: [],
      newjuniorFiveText: "",
      newjuniorSixSelected: [],
      newjuniorSixText: "",


      juniorOneSelected: [],
      juniorOneText: "",
      juniorTwoSelected: [],
      juniorTwoText: "",
      juniorThreeSelected: [],
      juniorThreeText: "",
      juniorFourSelected: [],
      juniorFourText: "",
      juniorFiveSelected: [],
      juniorFiveText: "",
      juniorSixSelected: [],
      juniorSixText: "",

      seniorOneSelected: [],
      seniorOneText: "",
      seniorTwoSelected: [],
      seniorTwoText: "",
      seniorThreeSelected: [],
      seniorThreeText: "",
      seniorFourSelected: [],
      seniorFourText: "",
      seniorFiveSelected: [],
      seniorFiveText: "",
      seniorSixSelected: [],
      seniorSixText: "",
      seniorSevenSelected: [],
      seniorSevenText: "",
    };
  },
  methods: {
    // 新七年级上
    newtoggleJuniorOne(index) {
      // 点击新七年级上选中
      this.$refs.checkboxes01[index].toggle();
    },
    newcheckJuniorOneAll() {
      // 选中新七年级上所有
      this.$refs.checkboxGroup01.toggleAll(true);
    },
    newtoggleJuniorOneAll() {
      // 反选新七年级上所有
      this.$refs.checkboxGroup01.toggleAll(false);
    },

    // 新七年级下
    newtoggleJuniorTwo(index) {
      // 点击新七年级下选中
      this.$refs.checkboxes02[index].toggle();
    },
    newcheckJuniorTwoAll() {
      // 选中新七年级下所有
      this.$refs.checkboxGroup02.toggleAll(true);
    },
    newtoggleJuniorTwoAll() {
      // 反选新七年级下所有
      this.$refs.checkboxGroup02.toggleAll(false);
    },

    // 新八年级上
    newtoggleJuniorThree(index) {
      // 点击新八年级上选中
      this.$refs.checkboxes03[index].toggle();
    },
    newcheckJuniorThreeAll() {
      // 选中新八年级上所有
      this.$refs.checkboxGroup03.toggleAll(true);
    },
    newtoggleJuniorThreeAll() {
      // 反选新八年级上所有
      this.$refs.checkboxGroup03.toggleAll(false);
    },

    // 新八年级下
    newtoggleJuniorFour(index) {
      // 点击新八年级下选中
      this.$refs.checkboxes04[index].toggle();
    },
    newcheckJuniorFourAll() {
      // 选中新八年级下所有
      this.$refs.checkboxGroup04.toggleAll(true);
    },
    newtoggleJuniorFourAll() {
      // 反选新八年级下所有
      this.$refs.checkboxGroup04.toggleAll(false);
    },

    // ================= 新增：新九年级上 =================
    newtoggleJuniorFive(index) {
      this.$refs.checkboxes05[index].toggle();
    },
    newcheckJuniorFiveAll() {
      this.$refs.checkboxGroup05.toggleAll(true);
    },
    newtoggleJuniorFiveAll() {
      this.$refs.checkboxGroup05.toggleAll(false);
    },

    // ================= 新增：新九年级下 =================
    newtoggleJuniorSix(index) {
      this.$refs.checkboxes06[index].toggle();
    },
    newcheckJuniorSixAll() {
      this.$refs.checkboxGroup06.toggleAll(true);
    },
    newtoggleJuniorSixAll() {
      this.$refs.checkboxGroup06.toggleAll(false);
    },

    // 七年级上
    toggleJuniorOne(index) {
      // 点击七年级上选中
      this.$refs.checkboxes1[index].toggle();
    },
    checkJuniorOneAll() {
      // 选中七年级上所有
      this.$refs.checkboxGroup1.toggleAll(true);
    },
    toggleJuniorOneAll() {
      // 反选七年级上所有
      this.$refs.checkboxGroup1.toggleAll(false);
    },
    // 七年级下
    toggleJuniorTwo(index) {
      // 点击七年级下选中
      this.$refs.checkboxes2[index].toggle();
    },
    checkJuniorTwoAll() {
      // 选中七年级下所有
      this.$refs.checkboxGroup2.toggleAll(true);
    },
    toggleJuniorTwoAll() {
      // 反选七年级下所有
      this.$refs.checkboxGroup2.toggleAll(false);
    },
    // 八年级上
    toggleJuniorThree(index) {
      // 点击八年级上选中
      this.$refs.checkboxes3[index].toggle();
    },
    checkJuniorThreeAll() {
      // 选中八年级上所有
      this.$refs.checkboxGroup3.toggleAll(true);
    },
    toggleJuniorThreeAll() {
      // 反选八年级上所有
      this.$refs.checkboxGroup3.toggleAll(false);
    },
    // 八年级下
    toggleJuniorFour(index) {
      // 点击八年级下选中
      this.$refs.checkboxes4[index].toggle();
    },
    checkJuniorFourAll() {
      // 选中八年级下所有
      this.$refs.checkboxGroup4.toggleAll(true);
    },
    toggleJuniorFourAll() {
      // 反选八年级下所有
      this.$refs.checkboxGroup4.toggleAll(false);
    },
    // 九年级上
    toggleJuniorFive(index) {
      // 点击九年级上选中
      this.$refs.checkboxes5[index].toggle();
    },
    checkJuniorFiveAll() {
      // 选中九年级上所有
      this.$refs.checkboxGroup5.toggleAll(true);
    },
    toggleJuniorFiveAll() {
      // 反选九年级上所有
      this.$refs.checkboxGroup5.toggleAll(false);
    },
    // 九年级下
    toggleJuniorSix(index) {
      // 点击九年级下选中
      this.$refs.checkboxes6[index].toggle();
    },
    checkJuniorSixAll() {
      // 选中九年级下所有
      this.$refs.checkboxGroup6.toggleAll(true);
    },
    toggleJuniorSixAll() {
      // 反选九年级下所有
      this.$refs.checkboxGroup6.toggleAll(false);
    },
    // 必修一
    toggleSeniorOne(index) {
      // 点击必修一选中
      this.$refs.checkboxes7[index].toggle();
    },
    checkSeniorOneAll() {
      // 选中必修一所有
      this.$refs.checkboxGroup7.toggleAll(true);
    },
    toggleSeniorOneAll() {
      // 反选必修一所有
      this.$refs.checkboxGroup7.toggleAll(false);
    },
    // 必修二
    toggleSeniorTwo(index) {
      // 点击必修二选中
      this.$refs.checkboxes8[index].toggle();
    },
    checkSeniorTwoAll() {
      // 选中必修二所有
      this.$refs.checkboxGroup8.toggleAll(true);
    },
    toggleSeniorTwoAll() {
      // 反选必修二所有
      this.$refs.checkboxGroup8.toggleAll(false);
    },
    // 必修三
    toggleSeniorThree(index) {
      // 点击必修三选中
      this.$refs.checkboxes9[index].toggle();
    },
    checkSeniorThreeAll() {
      // 选中必修三所有
      this.$refs.checkboxGroup9.toggleAll(true);
    },
    toggleSeniorThreeAll() {
      // 反选必修三所有
      this.$refs.checkboxGroup9.toggleAll(false);
    },
    // 选修一
    toggleSeniorFour(index) {
      // 点击选修一选中
      this.$refs.checkboxes10[index].toggle();
    },
    checkSeniorFourAll() {
      // 选中选修一所有
      this.$refs.checkboxGroup10.toggleAll(true);
    },
    toggleSeniorFourAll() {
      // 反选选修一所有
      this.$refs.checkboxGroup10.toggleAll(false);
    },
    // 选修二
    toggleSeniorFive(index) {
      // 点击选修二选中
      this.$refs.checkboxes11[index].toggle();
    },
    checkSeniorFiveAll() {
      // 选中选修二所有
      this.$refs.checkboxGroup11.toggleAll(true);
    },
    toggleSeniorFiveAll() {
      // 反选选修二所有
      this.$refs.checkboxGroup11.toggleAll(false);
    },
    // 选修三
    toggleSeniorSix(index) {
      // 点击选修三选中
      this.$refs.checkboxes12[index].toggle();
    },
    checkSeniorSixAll() {
      // 选中选修三所有
      this.$refs.checkboxGroup12.toggleAll(true);
    },
    toggleSeniorSixAll() {
      // 反选选修三所有
      this.$refs.checkboxGroup12.toggleAll(false);
    },
    // 选修四
    toggleSeniorSeven(index) {
      // 点击选修四选中
      this.$refs.checkboxes13[index].toggle();
    },
    checkSeniorSevenAll() {
      // 选中选修四所有
      this.$refs.checkboxGroup13.toggleAll(true);
    },
    toggleSeniorSevenAll() {
      // 反选选修四所有
      this.$refs.checkboxGroup13.toggleAll(false);
    },

    // 确认筛选
    filterTextbook() {
      this.$store.state.textbookSelected = [];
      this.$store.state.textbookValue = "";

      this.$store.state.textbookSelected.push(
        { newjuniorOneSelected: this.newjuniorOneSelected },
        { newjuniorTwoSelected: this.newjuniorTwoSelected },
        { newjuniorThreeSelected: this.newjuniorThreeSelected },
        { newjuniorFourSelected: this.newjuniorFourSelected },
        // 新增加入筛选器
        { newjuniorFiveSelected: this.newjuniorFiveSelected },
        { newjuniorSixSelected: this.newjuniorSixSelected },

        { juniorOneSelected: this.juniorOneSelected },
        { juniorTwoSelected: this.juniorTwoSelected },
        { juniorThreeSelected: this.juniorThreeSelected },
        { juniorFourSelected: this.juniorFourSelected },
        { juniorFiveSelected: this.juniorFiveSelected },
        { juniorSixSelected: this.juniorSixSelected },
        { seniorOneSelected: this.seniorOneSelected },
        { seniorTwoSelected: this.seniorTwoSelected },
        { seniorThreeSelected: this.seniorThreeSelected },
        { seniorFourSelected: this.seniorFourSelected },
        { seniorFiveSelected: this.seniorFiveSelected },
        { seniorSixSelected: this.seniorSixSelected },
        { seniorSevenSelected: this.seniorSevenSelected }
      );

      let moduleLength = 0;
      for (let i = 0; i < this.$store.state.textbookSelected.length; i++) {
        for (let key in this.$store.state.textbookSelected[i]) {
          let mLength = this.$store.state.textbookSelected[i][key].length;
          if (mLength != 0) {
            moduleLength = mLength + moduleLength;
          }
        }
      }

      let textbookLength = 0;
      for (let i = 0; i < this.$store.state.textbookSelected.length; i++) {
        for (let key in this.$store.state.textbookSelected[i]) {
          if (this.$store.state.textbookSelected[i][key].length != 0) {
            textbookLength = textbookLength + 1;
            continue;
          }
        }
      }

      this.$store.state.textbookValue =
        "选择" + textbookLength + "本书，" + moduleLength + "个单元";
      this.showPickerTextbook = false;
      this.foldCollamps();
      // console.log('textbookSelected', this.$store.state.textbookSelected)
      // console.log('textbookValue', this.$store.state.textbookValue)
    },
    clearTextbook() {
      // this.foldCollamps();
      this.newjuniorOneSelected = [];
      this.newjuniorTwoSelected = [];
      this.newjuniorThreeSelected = [];
      this.newjuniorFourSelected = [];
      // 新增清空
      this.newjuniorFiveSelected = [];
      this.newjuniorSixSelected = [];

      this.juniorOneSelected = [];
      this.juniorTwoSelected = [];
      this.juniorThreeSelected = [];
      this.juniorFourSelected = [];
      this.juniorFiveSelected = [];
      this.juniorSixSelected = [];

      this.seniorOneSelected = [];
      this.seniorTwoSelected = [];
      this.seniorThreeSelected = [];
      this.seniorFourSelected = [];
      this.seniorFiveSelected = [];
      this.seniorSixSelected = [];
      this.seniorSevenSelected = [];

      this.$store.state.textbookSelected = [];
      this.$store.state.textbookValue = "";
    },
    foldCollamps() {
      // 折叠所有项目
      for (let i = 0; i < this.$refs.collapsitems.children.length; i++) {
        if (this.$refs.collapsitems.children[i].expanded == true) {
          this.$refs.collapsitems.children[i].toggle();
          break;
        }
      }
    },
  },
  watch: {
    // 监听新七年级上
    newjuniorOneSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.newjuniorOneText = "全选";
            return;
          }
            this.newjuniorOneText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.newjuniorOneText = "";
        }
      },
    },
    // 监听新七年级下
    newjuniorTwoSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.newjuniorTwoText = "全选";
            return;
          }
          this.newjuniorTwoText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.newjuniorTwoText = "";
        }
      },
    },
    // 监听新八年级上
    newjuniorThreeSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.newjuniorThreeText = "全选";
            return;
          }
          this.newjuniorThreeText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.newjuniorThreeText = "";
        }
      },
    },
    // 监听新八年级下
    newjuniorFourSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.newjuniorFourText = "全选";
            return;
          }
          this.newjuniorFourText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.newjuniorFourText = "";
        }
      },
    },
    
    // ================= 新增监听：新九年级上 =================
    newjuniorFiveSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.newjuniorFiveText = "全选";
            return;
          }
          this.newjuniorFiveText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.newjuniorFiveText = "";
        }
      },
    },
    // ================= 新增监听：新九年级下 =================
    newjuniorSixSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.newjuniorSixText = "全选";
            return;
          }
          this.newjuniorSixText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.newjuniorSixText = "";
        }
      },
    },

    // 监听七年级上
    juniorOneSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 14) {
          if (textLength == 14) {
            this.juniorOneText = "全选";
            return;
          }
          this.juniorOneText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.juniorOneText = "";
        }
      },
    },
    // 监听七年级下
    juniorTwoSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 12) {
          if (textLength == 12) {
            this.juniorTwoText = "全选";
            return;
          }
          this.juniorTwoText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.juniorTwoText = "";
        }
      },
    },
    // 监听八年级上
    juniorThreeSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 12) {
          if (textLength == 12) {
            this.juniorThreeText = "全选";
            return;
          }
          this.juniorThreeText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.juniorThreeText = "";
        }
      },
    },
    // 监听八年级下
    juniorFourSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 10) {
          if (textLength == 10) {
            this.juniorFourText = "全选";
            return;
          }
          this.juniorFourText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.juniorFourText = "";
        }
      },
    },
    // 监听九年级上
    juniorFiveSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 12) {
          if (textLength == 12) {
            this.juniorFiveText = "全选";
            return;
          }
          this.juniorFiveText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.juniorFiveText = "";
        }
      },
    },
    // 监听九年级下
    juniorSixSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 8) {
          if (textLength == 8) {
            this.juniorSixText = "全选";
            return;
          }
          this.juniorSixText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.juniorSixText = "";
        }
      },
    },
    // 监听必修一
    seniorOneSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.seniorOneText = "全选";
            return;
          }
          this.seniorOneText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.seniorOneText = "";
        }
      },
    },
    // 监听必修二
    seniorTwoSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.seniorTwoText = "全选";
            return;
          }
          this.seniorTwoText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.seniorTwoText = "";
        }
      },
    },
    // 监听必修三
    seniorThreeSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.seniorThreeText = "全选";
            return;
          }
          this.seniorThreeText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.seniorThreeText = "";
        }
      },
    },
    // 监听选修一
    seniorFourSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.seniorFourText = "全选";
            return;
          }
          this.seniorFourText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.seniorFourText = "";
        }
      },
    },
    // 监听选修二
    seniorFiveSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.seniorFiveText = "全选";
            return;
          }
          this.seniorFiveText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.seniorFiveText = "";
        }
      },
    },
    // 监听选修三
    seniorSixSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.seniorSixText = "全选";
            return;
          }
          this.seniorSixText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.seniorSixText = "";
        }
      },
    },
    // 监听选修四
    seniorSevenSelected: {
      handler(newVal, oldVal) {
        const textLength = newVal.length;
        // console.log('textLength', textLength)
        if (1 < textLength <= 6) {
          if (textLength == 6) {
            this.seniorSevenText = "全选";
            return;
          }
          this.seniorSevenText = "选中" + textLength + "个";
        }
        if (textLength == 0) {
          this.seniorSevenText = "";
        }
      },
    },
  },
  mounted() {},
};
</script>

<style scoped>
.selectAllButton {
  height: 30px;
  margin-right: 1%;
}
.unSelectAllButton {
  height: 30px;
}
</style>